import {useState} from 'react'
import {Link, useSearchParams} from 'react-router-dom'
import {resendVerification} from '../core/_requests'
import {Toast} from '../../../../ui-kit'

export function EmailVerificationSent() {
  const [searchParams] = useSearchParams()
  const email = searchParams.get('email')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  const handleResend = async () => {
    if (!email) return
    setLoading(true)
    try {
      await resendVerification(email)
      setSent(true)
      Toast('Verification email sent!', 'success', '')
    } catch (error: any) {
      console.error(error)
      Toast('Failed to resend verification email', 'danger', error.response?.data?.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='w-100'>
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Verify your email</h1>
        <div className='text-gray-500 fw-semibold fs-6'>
          We have sent a verification link to <b className='text-dark'>{email}</b>.
        </div>
      </div>

      <div className='text-center mb-10'>
        <p className='text-gray-500 fw-semibold fs-6'>
          Didn't receive the email? Check your spam folder or click the button below to resend.
        </p>
      </div>

      <div className='d-grid mb-10'>
        <button
          type='button'
          className='btn btn-primary'
          onClick={handleResend}
          disabled={loading || sent}
        >
          {!loading && <span className='indicator-label'>{sent ? 'Sent!' : 'Resend Email'}</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>

      <div className='text-center'>
        <Link to='/auth/login' className='link-primary fw-bolder'>
          Back to Login
        </Link>
      </div>
    </div>
  )
}
